(function () {
  'use strict';

  var stickyBar = document.getElementById('sticky-cta-mobil');
  if (!stickyBar) return;

  var buyButtonsTarget = document.querySelector('.product-form__buttons');
  if (!buyButtonsTarget) {
    buyButtonsTarget = document.querySelector('[id^="ProductSubmitButton-"]');
  }
  if (!buyButtonsTarget) return;

  var SYNLIG = 'is-synlig';

  // IntersectionObserver: vis sticky-bar nar hoved-CTA er ute av viewport
  var observer = new IntersectionObserver(
    function (entries) {
      var entry = entries[0];
      if (entry.isIntersecting) {
        stickyBar.classList.remove(SYNLIG);
        stickyBar.setAttribute('aria-hidden', 'true');
      } else {
        stickyBar.classList.add(SYNLIG);
        stickyBar.setAttribute('aria-hidden', 'false');
      }
    },
    { root: null, threshold: 0 }
  );

  observer.observe(buyButtonsTarget);

  /* ─── Hent variant-ID fra produktskjemaet ─── */
  function hentVariantId() {
    var formId = stickyBar.getAttribute('data-product-form-id');
    var form = formId ? document.getElementById('product-form-' + formId) : null;
    if (!form) form = document.querySelector('form[action="/cart/add"]');
    if (!form) return null;
    var input = form.querySelector('[name="id"]');
    return input ? input.value : null;
  }

  /* ─── Oppdater handlekurv-innhold og åpne draweren ───
     Erstatter hele #CartDrawer.innerHTML (samme som Dawn's renderContents),
     slik at is-empty-tilstand, .drawer__inner-empty og alle CSS-klasser
     synkroniseres korrekt med faktisk handlekurv-status. */
  function oppdaterOgAapne() {
    var path = window.location.pathname.split('?')[0];
    return fetch(path + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var parser = new DOMParser();

        /* Oppdater handlekurv-boble i topp-nav */
        if (data['cart-icon-bubble']) {
          var doc = parser.parseFromString(data['cart-icon-bubble'], 'text/html');
          var nyBoble = doc.querySelector('#cart-icon-bubble');
          var boble = document.querySelector('#cart-icon-bubble');
          if (nyBoble && boble) boble.innerHTML = nyBoble.innerHTML;
        }

        if (data['cart-drawer']) {
          var doc2 = parser.parseFromString(data['cart-drawer'], 'text/html');

          /* Erstatt hele #CartDrawer-innholdet — samme som Dawn gjør i
             renderContents(). Dette håndterer is-empty, .drawer__inner-empty,
             cart-drawer-items.is-empty og all annen tilstandsstyring. */
          var nyCartDrawer = doc2.querySelector('#CartDrawer');
          var eksCartDrawer = document.querySelector('#CartDrawer');
          if (nyCartDrawer && eksCartDrawer) {
            eksCartDrawer.innerHTML = nyCartDrawer.innerHTML;
          }

          /* Synkroniser is-empty-klassen på <cart-drawer>-elementet */
          var nyCD = doc2.querySelector('cart-drawer');
          var eksCD = document.querySelector('cart-drawer');
          if (nyCD && eksCD) {
            eksCD.classList.toggle('is-empty', nyCD.classList.contains('is-empty'));
          }
        }

        /* Åpne draweren */
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          if (typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          } else {
            cartDrawer.classList.add('active', 'animate');
            document.body.classList.add('overflow-hidden');
          }
        }
      });
  }

  /* ─── Klikk på sticky-knapp: legg til direkte via API ─── */
  var stickyKnapp = document.getElementById('sticky-cta-mobil-knapp');
  if (stickyKnapp) {
    stickyKnapp.addEventListener('click', function () {
      var variantId = hentVariantId();
      if (!variantId) return;

      stickyKnapp.disabled = true;
      var originalTekst = stickyKnapp.textContent;
      stickyKnapp.textContent = '...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId, 10), quantity: 1 }]
        })
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.status) {
            // Shopify returnerte en feil (f.eks. ikke på lager)
            stickyKnapp.textContent = data.description || 'Ikke tilgjengelig';
            setTimeout(function () {
              stickyKnapp.textContent = originalTekst;
              stickyKnapp.disabled = false;
            }, 2500);
            return;
          }
          stickyKnapp.textContent = 'Lagt til!';
          return oppdaterOgAapne().then(function () {
            setTimeout(function () {
              stickyKnapp.textContent = originalTekst;
              stickyKnapp.disabled = false;
            }, 2000);
          });
        })
        .catch(function () {
          stickyKnapp.textContent = originalTekst;
          stickyKnapp.disabled = false;
        });
    });
  }

  // Oppdater pris i sticky-baren ved variant-bytte (Dawn publishes 'variant-change' event)
  if (typeof subscribe === 'function') {
    subscribe('variant-change', function (eventData) {
      if (!eventData || !eventData.data || !eventData.data.variant) return;
      var variant = eventData.data.variant;

      var prisEl = stickyBar.querySelector('.sticky-cta-mobil__pris');
      if (!prisEl) return;

      var formatMoney = window.Shopify && window.Shopify.formatMoney
        ? window.Shopify.formatMoney
        : function (cents) {
            return (cents / 100).toLocaleString('nb-NO', {
              minimumFractionDigits: 0,
              maximumFractionDigits: 0
            }) + ' kr';
          };

      var kampanjeWrap = document.querySelector('[id^="kampanje-pris-"]');
      var harKampanje = kampanjeWrap && window.getComputedStyle(kampanjeWrap).display !== 'none';
      var prosent = kampanjeWrap ? parseInt(kampanjeWrap.getAttribute('data-prosent') || '15', 10) : 15;

      if (harKampanje && variant.available) {
        var kampanjePrisCents = Math.floor(variant.price * (100 - prosent) / 100);
        prisEl.innerHTML =
          '<span class="sticky-cta-mobil__pris--kampanje">' + formatMoney(kampanjePrisCents) + '</span>' +
          '<span class="sticky-cta-mobil__pris--original">' + formatMoney(variant.price) + '</span>';
      } else {
        prisEl.textContent = formatMoney(variant.price);
      }

      if (stickyKnapp) {
        stickyKnapp.disabled = !variant.available;
        stickyKnapp.textContent = variant.available ? 'Legg i handlekurv' : 'Ikke på lager';
      }
    });
  }
})();
